module.exports = __webpack_public_path__ + "static/media/map-lg-logo.0ffbce87.jpg";